namespace advisorop.domains {
    "use strict";

    export interface IAFExtinterface {
        id?: number;
        advisoryFirmId?: number;
        extinterfaceType?: ExternalSystemType;
        extinterface?: ExternalSystem;
        status?: Status;
        extinterfaceTypeDescription?: string;
        extinterfaceDescription?: string;
    }

    export interface IAFAssetClassnModel extends IAdvisorOpTable {
        name?: string;
        isActive?: boolean;
        locked?: boolean;
        advisoryFirmId?: number;
        advisoryFirm?: IAdvisoryFirm;
    }

    export interface IAFAssetClassnClassn extends IAdvisorOpTable {
        name?: string;
        aFAssetClassnModelId ?: number;
        classnId?: string;
        parentClassnId?: string;
        orderIndex?: number;
    }

    export interface IFAssetClassModelAndClassifications {
        model: IAFAssetClassnModel;
        classifications: IAFAssetClassnClassn[];
    }
}
